import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class StoreAuthService {

  public static readonly TAG = "StoreAuthService";

  // private loading: boolean = false;

  private isLoggedIn: boolean;
  private isLoggedInBehaviorSubject: BehaviorSubject<boolean>;
  private isLoggedInObservable: Observable<boolean>;

  private loginUserName: string;
  private loginUserNameBehaviorSubject: BehaviorSubject<string>;
  private loginUserNameObservable: Observable<string>;

  // JobTitleCode
  private loginUserJobTitleCode: string = null;

  constructor(
  ) {
    this.isLoggedIn = false;

    this.isLoggedInBehaviorSubject = new BehaviorSubject<boolean>(false);
    this.isLoggedInObservable = this.isLoggedInBehaviorSubject.asObservable();

    const cachedUserName = localStorage.getItem('gokuri.loginUserName') || '';
    this.loginUserName = cachedUserName;
    this.loginUserNameBehaviorSubject = new BehaviorSubject<string>(cachedUserName);
    this.loginUserNameObservable = this.loginUserNameBehaviorSubject.asObservable();

  }

  setIsLoggedIn(isLoggedIn: boolean): void {

    this.isLoggedIn = isLoggedIn;
    this.isLoggedInBehaviorSubject.next(isLoggedIn);
  }

  getIsLoggedIn(): boolean {
    return this.isLoggedIn;
  }

  getIsLoggedInOservable(): Observable<boolean> {
    return this.isLoggedInObservable;
  }

  setLoginUserName(loginUserName: string): void {

    this.loginUserName = loginUserName;
    localStorage.setItem('gokuri.loginUserName', loginUserName);
    this.loginUserNameBehaviorSubject.next(loginUserName);
  }

  getLoginUserName(): string {
    return this.loginUserName || localStorage.getItem('gokuri.loginUserName');
  }

  getLoginUserNameObservable(): Observable<string> {
    return this.loginUserNameObservable;
  }

  setJobTitleCode(jobTitleCode: string): void {
    this.loginUserJobTitleCode = jobTitleCode;
  }

  getJobTitleCode(): string {
    return this.loginUserJobTitleCode;
  }

}
